import { IntegrationOrganizationItemModel, IntegrationsModel } from "../../models/integrations.model";

export const GenericIntegration_STATE_PATH = 'genericIntegration';

export class GenericIntegrationStateModel {
	integrations: IntegrationsModel[];
	integration: IntegrationsModel;
	organization: IntegrationOrganizationItemModel;
	mappers: string[];
	menu: any[];
	backUrl: string;

	constructor() {
		this.integrations = [];
		this.integration = null;
		this.organization = null;
		this.mappers = [];
		this.menu = [];
		this.backUrl = '';
	}
}

